import type { CustomerPersonaCard } from '../components/CustomersPanel';
import { readPersonaSignals } from './personaSignals';

function readPersonaTitle(persona: Record<string, unknown>): string {
  for (const field of ['personaTitle', 'segment', 'title', 'name']) {
    const v = persona[field];
    if (typeof v === 'string' && v.trim()) return v.trim();
  }
  return '';
}

export function toPersonaCard(persona: Record<string, unknown>, index: number): CustomerPersonaCard {
  return {
    index,
    segment: readPersonaTitle(persona),
    scope: typeof persona.scope === 'string' ? persona.scope : undefined,
    description: typeof persona.description === 'string' ? persona.description : undefined,
    signals: readPersonaSignals(persona.signals),
  };
}

export function personaCardsFromProgress(raw: unknown): CustomerPersonaCard[] {
  const values = Array.isArray(raw)
    ? raw
    : raw && typeof raw === 'object'
      ? Object.values(raw as Record<string, unknown>)
      : [];

  return values
    .filter((value): value is Record<string, unknown> => !!value && typeof value === 'object' && !Array.isArray(value))
    .filter(value => typeof value.index === 'number' && value.index >= 0)
    .map(value => toPersonaCard(value, value.index as number))
    .filter(card => !!card.segment)
    .sort((a, b) => a.index - b.index);
}
